@import "../../global/normalize.css";

:host ::part(button) {
  color: var(--ic-popover-menu-item-check);

  --ic-typography-color: var(--ic-popover-menu-item-check);

  padding: calc(var(--ic-space-xxxs) / 2);
  display: flex;
  align-items: flex-start;
  gap: var(--ic-space-xs);
  border-radius: 0;
  min-height: 2.5rem;
  height: auto;
}

.focus-border {
  display: flex;
  align-items: flex-start;
  gap: var(--ic-space-xs);
  border-radius: var(--ic-border-radius);
  margin: calc(var(--ic-space-xxxs) / 2);
  padding: var(--ic-space-xxs);
  border: var(--ic-space-xxxs) dashed transparent;

  --icon-height: auto;
}

:host(.ic-menu-item-disabled) ::part(button) {
  color: var(--ic-popover-menu-item-check-disabled) !important;

  --ic-typography-color: var(--ic-popover-menu-item-check-disabled) !important;

  pointer-events: none;
}

:host(.ic-menu-item-disabled) .menu-item-label,
:host(.ic-menu-item-disabled) .shortcut,
:host(.ic-menu-item-disabled) .menu-item-description {
  --ic-typography-color: var(--ic-popover-menu-item-label-disabled) !important;
}

:host(.ic-menu-item-variant-destructive) ::part(button) {
  color: var(--ic-popover-menu-destructive-item-icon);

  --ic-typography-color: var(--ic-popover-menu-destructive-item-label);
}

:host ::part(button):hover {
  background-color: var(--ic-popover-background-hover);
}

:host ::part(button):focus-visible,
:host ::part(button):focus {
  color: var(--ic-popover-menu-item-icon-focused);

  --ic-typography-color: purple;

  background-color: var(--ic-popover-background-focus);
  box-shadow: none;
}

:host(.ic-menu-item-disabled) ::part(button):focus-visible,
:host(.ic-menu-item-disabled) ::part(button):focus {
  color: var(--ic-popover-menu-item-icon-disabled) !important;

  --ic-typography-color: orange !important;
}

:host(.ic-menu-item-variant-destructive) ::part(button):focus-visible,
:host(.ic-menu-item-variant-destructive) ::part(button):focus {
  background-color: var(--ic-popover-destructive-background-focus);
}

ic-button:focus-within .menu-item-label,
ic-button:focus-within .shortcut,
ic-button:focus-within .menu-item-description {
  --ic-typography-color: var(--ic-popover-menu-item-label-focused);
}

:host(.ic-menu-item-disabled) ic-button:focus-within .focus-border {
  border-color: var(--ic-popover-menu-border);
}

:host(.ic-menu-item-disabled) ic-button:focus-within .menu-item-label,
:host(.ic-menu-item-disabled) ic-button:focus-within .shortcut,
:host(.ic-menu-item-disabled) ic-button:focus-within .menu-item-description {
  --ic-typography-color: var(--ic-popover-menu-item-label-disabled) !important;
}

:host ::part(button):active {
  background-color: var(--ic-popover-background-pressed);
  color: var(--ic-popover-menu-item-label) !important;

  --ic-typography-color: var(--ic-popover-menu-item-label) !important;
}

:host(.ic-menu-item-variant-destructive) ::part(button):active {
  background-color: var(--ic-popover-background-pressed);
  color: var(--ic-popover-menu-destructive-item-label) !important;

  --ic-typography-color: var(
    --ic-popover-menu-destructive-item-label
  ) !important;
}

.menu-item-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: baseline;
  white-space: pre-line;
  text-align: left;
}

.menu-labels {
  display: flex;
  align-items: baseline;
  gap: var(--ic-space-xs);
}

.menu-item-description {
  --ic-typography-color: var(--ic-popover-menu-item-description);
}

.shortcut {
  --ic-typography-color: var(--ic-popover-menu-item-shortcut);

  display: flex;
  flex: min-content;
}

:host(.ic-menu-item-variant-destructive) .menu-item-label {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.025em;
}

ic-button:active .menu-item-label {
  --ic-typography-color: var(--ic-popover-menu-item-label);
}

ic-button:active .menu-item-description {
  --ic-typography-color: var(--ic-popover-menu-item-description);
}

ic-button:active .shortcut {
  --ic-typography-color: var(--ic-popover-menu-item-shortcut);
}

:host(.ic-menu-item-variant-destructive) ic-button:active .menu-item-label {
  --ic-typography-color: var(
    --ic-popover-menu-destructive-item-label
  ) !important;
}

.icon,
.check-icon,
.submenu-icon,
.icon ::slotted(svg),
.check-icon svg,
.submenu-icon svg {
  width: var(--ic-space-lg);
  height: var(--ic-space-lg);
}

.check-icon.hide {
  visibility: hidden;
}

/** High Contrast **/
@media (forced-colors: active) {
  :host ::part(button) {
    border: canvas;
  }

  :host ::part(button):focus-visible {
    outline: var(--ic-space-xxxs) solid transparent;
  }

  .focus-border {
    border-color: canvas;
  }

  :host(.ic-menu-item-disabled) ic-button:focus-within .focus-border {
    border-color: GrayText;
  }

  :host(.ic-menu-item-disabled) .menu-item-info,
  :host(.ic-menu-item-disabled) .menu-item-label,
  :host(.ic-menu-item-disabled) .shortcut,
  :host(.ic-menu-item-disabled) .menu-item-description,
  :host(.ic-menu-item-disabled) ic-button:focus-within .menu-item-info,
  :host(.ic-menu-item-disabled) ic-button:focus-within .menu-item-label,
  :host(.ic-menu-item-disabled) ic-button:focus-within .shortcut,
  :host(.ic-menu-item-disabled) ic-button:focus-within .menu-item-description {
    --ic-typography-color: GrayText !important;
  }

  :host(.ic-menu-item-disabled) ::part(button):focus-visible,
  :host(.ic-menu-item-disabled) ::part(button):focus {
    outline-color: GrayText !important;
  }
}
